/* eslint-disable import/prefer-default-export */
import { range } from "lodash";
import {
  nonEditable,
  textCell,
  headerCell
} from "../cells";
import { HEADER_ROW_ID, ROW_HEIGHT } from "../constants";
import { formatCurrency } from "@/utils/helpers";

function getHeaderRow(columns) {
  return {
    rowId: HEADER_ROW_ID,
    height: ROW_HEIGHT,
    cells: columns.map((column) => headerCell(column.label)),
  };
}

function getGroupRows(title, groups, totalDebit, totalCredit, columns, openingBalance, closingBalance, debit, credit) {
  if (groups?.length) {
    return [
      {
        rowId: `${title}-First-Row`,
        height: ROW_HEIGHT,
        cells: [
          ...range(0, columns.length - 5).map(() => headerCell("", "total-row")),
          headerCell(
            "", "total-row"),
          headerCell(formatCurrency(openingBalance || 0), "total-row-credit"),
          headerCell(formatCurrency(debit || 0), "total-row-credit"),
          headerCell(formatCurrency(credit || 0), "total-row-credit"),
          headerCell(formatCurrency(closingBalance || 0), "total-row-credit"),
        ],
      },
      ...groups.map((item, index) => ({
        rowId: item.id,
        height: ROW_HEIGHT,
        cells: columns.map((column) => {
          const textCellArgs = {};

          if (column.formatter) {
            textCellArgs.text = column.formatter(item[column.columnId], index);
          } else {
            textCellArgs.text = item[column.columnId] ?? "";
          }

          return nonEditable(textCell(textCellArgs), column.className || "");
        }),
      })),
      {
        rowId: `${title}-Footer`,
        height: ROW_HEIGHT,
        cells: [
          ...range(0, columns.length - 4).map(() => headerCell("", "total-row")),
          headerCell(
            "Total", "total-row-debit"),
          headerCell(formatCurrency(totalDebit || 0), "total-row-credit"),
          headerCell(formatCurrency(totalCredit || 0), "total-row-credit"),
          headerCell("", "total-row"),

        ],
      },
    ];
  }
  return [];
}

export function getBankAccountStatementRows({
  data,
  columns
}) {
  let grandTotalCredit = 0;
  let grandTotalDebit = 0;

  if (data?.data?.length < 1) {
    return [];
  }
  const {
    openingBalance, closingBalance, debit, credit
  } = data.data[0];
  grandTotalCredit = data.data.reduce((acc, obj) => acc + +(obj.credit || 0), 0);
  grandTotalCredit -= credit;
  grandTotalDebit = data.data.reduce((acc, obj) => acc + +(obj.debit || 0), 0);
  grandTotalDebit -= debit;
  return [getHeaderRow(columns), ...getGroupRows("Total", data.data, grandTotalDebit, grandTotalCredit, columns, openingBalance, closingBalance, debit, credit)];
}
